var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 20,
    viewBox: "0 0 15.556 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete_Icon",
    "data-name": "Delete Icon",
    d: "M6.111,20.778A2.229,2.229,0,0,0,8.333,23h8.889a2.229,2.229,0,0,0,2.222-2.222V7.444H6.111ZM8.333,9.667h8.889V20.778H8.333Zm8.333-5.556L15.556,3H10L8.889,4.111H5V6.333H20.556V4.111Z",
    transform: "translate(-5 -3)",
    fill: "#474b4f",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete Icon.bfbe56041e98cbabf1c8948cbfed5eeb.svg";
export { ForwardRef as ReactComponent };